import { ENTERPRISE_CREATIVES_BUFFER_NONE_VALUE } from "./config/enterpriseIntakeModuleFieldRegistry";

const asString = (v) => (v == null ? "" : String(v));

export const isModuleSelected = ({ selectedModules, moduleValue }) =>
  Array.isArray(selectedModules) && selectedModules.includes(moduleValue);

export const isNonNegativeIntegerString = (val) => {
  const trimmed = asString(val).trim();
  if (!trimmed) return false;
  const num = parseInt(trimmed, 10);
  return !isNaN(num) && num >= 0 && String(num) === trimmed;
};

export const isPositiveIntegerString = (val) => {
  const trimmed = asString(val).trim();
  if (!trimmed) return false;
  const num = parseInt(trimmed, 10);
  return !isNaN(num) && num >= 1 && String(num) === trimmed;
};

export const isPercentIntegerString = (val) => {
  const trimmed = asString(val).trim();
  if (!trimmed) return false;
  const num = parseInt(trimmed, 10);
  return !isNaN(num) && num >= 1 && num <= 100 && String(num) === trimmed;
};

export const toggleExclusiveNoneValues = ({
  previousValues = [],
  nextValues = [],
  noneValue = ENTERPRISE_CREATIVES_BUFFER_NONE_VALUE,
}) => {
  const previous = Array.isArray(previousValues) ? previousValues : [];
  const next = Array.isArray(nextValues) ? nextValues : [];
  const addedNone = next.includes(noneValue) && !previous.includes(noneValue);
  if (addedNone) return [noneValue];
  return next.filter((value) => value !== noneValue);
};
